/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Women add the hip measurement to the calculation.`)
};

const es_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las mujeres añaden la medida de cadera al cálculo.`)
};

const de_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Frauen fließt zusätzlich das Hüftmaß in die Berechnung ein.`)
};

const nl_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bij vrouwen wordt de heupmaat aan de berekening toegevoegd.`)
};

const fr_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les femmes ajoutent la mesure des hanches au calcul.`)
};

const it_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le donne aggiungono la misura dei fianchi al calcolo.`)
};

const pt_br2_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As mulheres somam a medida do quadril ao cálculo.`)
};

const pt_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As mulheres acrescentam a medida da anca ao cálculo.`)
};

const ja_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性はヒップ周りの測定値が計算に加わります。`)
};

const zh_bf_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`女性需要在计算中加入臀围数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_ex2", locale)
	if (locale === "en") return en_bf_ex2(inputs)
	if (locale === "es") return es_bf_ex2(inputs)
	if (locale === "de") return de_bf_ex2(inputs)
	if (locale === "nl") return nl_bf_ex2(inputs)
	if (locale === "fr") return fr_bf_ex2(inputs)
	if (locale === "it") return it_bf_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_bf_ex2(inputs)
	if (locale === "pt") return pt_bf_ex2(inputs)
	if (locale === "ja") return ja_bf_ex2(inputs)
	return zh_bf_ex2(inputs)
};